// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.reports-scroll {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: auto;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
}

.reports-table .filename-cell {
  padding: 10px;
  text-align: left;
}

.reports-table .button-cell {
  width: 140px;
  padding: 10px;
  text-align: center;
}

.reports-table tr:nth-child(even) { background-color: #ffffff; }
.reports-table tr:hover            { background-color: #f0f0f0; }

.reports-table td {
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.reports-scroll::-webkit-scrollbar       { width: 6px; }
.reports-scroll::-webkit-scrollbar-track { background: var(--color-bg-row); border-radius: 4px; }
.reports-scroll::-webkit-scrollbar-thumb {
  background: var(--gradient-scroll);
  border-radius: 4px;
}

/* ─── Reports page (rp-*) ────────────────────────────────────────────────── */
.rp-page { font-size: 13px; color: var(--color-text); }

.rp-latest {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.rp-latest__body { display: flex; flex-direction: column; gap: 4px; min-width: 0; }

.rp-eyebrow {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-accent);
}

.rp-latest__title { margin: 0; font-size: 18px; font-weight: 600; color: var(--color-text); }

.rp-meta, .rp-note { margin: 0; font-size: 12px; color: var(--color-dim); }
.rp-note { line-height: 1.5; }

.rp-actions { display: flex; gap: 10px; flex-wrap: wrap; }

.rp-btn {
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  background: var(--gradient-accent);
  color: var(--color-white);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity 0.15s;
}
.rp-btn:hover:not(:disabled) { opacity: 0.85; }
.rp-btn:disabled { opacity: 0.5; cursor: default; }
.rp-btn--outline { background: transparent; border: 1px solid var(--color-border); color: var(--color-muted); }
.rp-btn--outline:hover:not(:disabled) { border-color: var(--color-muted); color: var(--color-text); opacity: 1; }

.rp-section-title {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-text);
}
.rp-section-title span { margin-left: 8px; color: var(--color-dim); font-weight: 400; letter-spacing: 0.04em; }

.rp-month { border-top: 1px solid var(--color-border); }
.rp-month:first-of-type { margin-top: 16px; }

.rp-month summary {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  cursor: pointer;
  list-style: none;
}
.rp-month summary::-webkit-details-marker { display: none; }
.rp-month summary::before {
  content: "▸";
  color: var(--color-dim);
  transition: transform 0.15s;
}
.rp-month[open] summary::before { transform: rotate(90deg); }
.rp-month summary:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }

.rp-count { font-size: 11px; font-weight: 400; color: var(--color-dim); }

.rp-list { list-style: none; margin: 0 0 8px; padding: 0; }

.rp-row {
  display: grid;
  grid-template-columns: minmax(170px, 1.4fr) 1fr 70px auto;
  align-items: center;
  gap: 12px;
  padding: 9px 0 9px 18px;
  border-top: 1px solid var(--color-border);
  font-size: 12px;
}
.rp-row:hover { background: var(--color-bg-row); }
.rp-row__when { color: var(--color-text); }
.rp-row__fund { color: var(--color-muted); }
.rp-row__size { color: var(--color-dim); text-align: right; font-variant-numeric: tabular-nums; }
.rp-row__actions { display: flex; gap: 14px; justify-content: flex-end; padding-right: 4px; }

.rp-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 12px;
  color: var(--color-accent);
  cursor: pointer;
  white-space: nowrap;
}
.rp-link:hover:not(:disabled) { text-decoration: underline; }
.rp-link:disabled { color: var(--color-dim); cursor: default; }

.rp-error { max-width: 1200px; margin: 0 auto 16px; font-size: 12px; color: var(--color-danger); }

.rp-message { display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; padding: 40px 20px; }
.rp-message__title { margin: 0; font-size: 14px; font-weight: 600; color: var(--color-text); }
.rp-message .rp-btn { margin-top: 8px; }

/* Loading placeholders */
.rp-skeleton {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--color-bg-row) 25%, var(--color-border) 50%, var(--color-bg-row) 75%);
  background-size: 200% 100%;
  animation: rp-shimmer 1.4s ease-in-out infinite;
}
.rp-skeleton--short { width: 90px; height: 10px; }
.rp-skeleton--title { width: 160px; height: 16px; margin: 4px 0; }
.rp-skeleton--meta  { width: 220px; height: 10px; }
.rp-skeleton--row   { height: 14px; margin: 14px 0; }

@keyframes rp-shimmer {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .rp-skeleton { animation: none; }
}

@media (max-width: 640px) {
  .rp-row { grid-template-columns: 1fr auto; padding-left: 4px; }
  .rp-row__fund { display: none; }
  .rp-row__actions { grid-column: 1 / -1; justify-content: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/Reports.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA,oCAAoC,yBAAyB,EAAE;AAC/D,qCAAqC,yBAAyB,EAAE;;AAEhE;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA,2CAA2C,UAAU,EAAE;AACvD,2CAA2C,+BAA+B,EAAE,kBAAkB,EAAE;AAChG;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E,WAAW,eAAe,EAAE,wBAAwB,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;;AAElF;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,oBAAoB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;;AAE5F,qBAAqB,SAAS,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC1E,WAAW,gBAAgB,EAAE;;AAE7B,cAAc,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEzD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;AACA,+BAA+B,aAAa,EAAE;AAC9C,mBAAmB,YAAY,EAAE,eAAe,EAAE;AAClD,mBAAmB,uBAAuB,EAAE,qCAAqC,EAAE,yBAAyB,EAAE;AAC9G,wCAAwC,gCAAgC,EAAE,wBAAwB,EAAE,UAAU,EAAE;;AAEhH;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA,yBAAyB,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE9G,YAAY,yCAAyC,EAAE;AACvD,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA,4CAA4C,aAAa,EAAE;AAC3D;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,kCAAkC,wBAAwB,EAAE;AAC5D,kCAAkC,sCAAsC,EAAE,mBAAmB,EAAE;;AAE/F,YAAY,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAExE,WAAW,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE;;AAE1D;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,yCAAyC;EACzC,eAAe;AACjB;AACA,gBAAgB,+BAA+B,EAAE;AACjD,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,uBAAuB,EAAE,iBAAiB,EAAE,kCAAkC,EAAE;AAChG,mBAAmB,aAAa,EAAE,SAAS,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;;AAE5F;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC,0BAA0B,EAAE;AAC5D,oBAAoB,uBAAuB,EAAE,eAAe,EAAE;;AAE9D,YAAY,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,0BAA0B,EAAE;;AAEjG,cAAc,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC5H,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AAC7F,sBAAsB,eAAe,EAAE;;AAEvC,yBAAyB;AACzB;EACE,cAAc;EACd,kBAAkB;EAClB,6GAA6G;EAC7G,0BAA0B;EAC1B,+CAA+C;AACjD;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,sBAAsB,YAAY,EAAE,YAAY,EAAE,aAAa,EAAE;AACjE,sBAAsB,YAAY,EAAE,YAAY,EAAE;AAClD,sBAAsB,YAAY,EAAE,cAAc,EAAE;;AAEpD;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,eAAe,eAAe,EAAE;AAClC;;AAEA;EACE,UAAU,+BAA+B,EAAE,iBAAiB,EAAE;EAC9D,gBAAgB,aAAa,EAAE;EAC/B,mBAAmB,mBAAmB,EAAE,2BAA2B,EAAE;AACvE","sourcesContent":[".reports-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.reports-scroll {\n  max-height: calc(100vh - 280px);\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.reports-table .filename-cell {\n  padding: 10px;\n  text-align: left;\n}\n\n.reports-table .button-cell {\n  width: 140px;\n  padding: 10px;\n  text-align: center;\n}\n\n.reports-table tr:nth-child(even) { background-color: #ffffff; }\n.reports-table tr:hover            { background-color: #f0f0f0; }\n\n.reports-table td {\n  border-top: 1px solid var(--color-border);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.reports-scroll::-webkit-scrollbar       { width: 6px; }\n.reports-scroll::-webkit-scrollbar-track { background: var(--color-bg-row); border-radius: 4px; }\n.reports-scroll::-webkit-scrollbar-thumb {\n  background: var(--gradient-scroll);\n  border-radius: 4px;\n}\n\n/* ─── Reports page (rp-*) ────────────────────────────────────────────────── */\n.rp-page { font-size: 13px; color: var(--color-text); }\n\n.rp-latest {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.rp-latest__body { display: flex; flex-direction: column; gap: 4px; min-width: 0; }\n\n.rp-eyebrow {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-accent);\n}\n\n.rp-latest__title { margin: 0; font-size: 18px; font-weight: 600; color: var(--color-text); }\n\n.rp-meta, .rp-note { margin: 0; font-size: 12px; color: var(--color-dim); }\n.rp-note { line-height: 1.5; }\n\n.rp-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n\n.rp-btn {\n  padding: 10px 20px;\n  border-radius: 6px;\n  border: none;\n  background: var(--gradient-accent);\n  color: var(--color-white);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.rp-btn:hover:not(:disabled) { opacity: 0.85; }\n.rp-btn:disabled { opacity: 0.5; cursor: default; }\n.rp-btn--outline { background: transparent; border: 1px solid var(--color-border); color: var(--color-muted); }\n.rp-btn--outline:hover:not(:disabled) { border-color: var(--color-muted); color: var(--color-text); opacity: 1; }\n\n.rp-section-title {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-text);\n}\n.rp-section-title span { margin-left: 8px; color: var(--color-dim); font-weight: 400; letter-spacing: 0.04em; }\n\n.rp-month { border-top: 1px solid var(--color-border); }\n.rp-month:first-of-type { margin-top: 16px; }\n\n.rp-month summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n  cursor: pointer;\n  list-style: none;\n}\n.rp-month summary::-webkit-details-marker { display: none; }\n.rp-month summary::before {\n  content: \"▸\";\n  color: var(--color-dim);\n  transition: transform 0.15s;\n}\n.rp-month[open] summary::before { transform: rotate(90deg); }\n.rp-month summary:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }\n\n.rp-count { font-size: 11px; font-weight: 400; color: var(--color-dim); }\n\n.rp-list { list-style: none; margin: 0 0 8px; padding: 0; }\n\n.rp-row {\n  display: grid;\n  grid-template-columns: minmax(170px, 1.4fr) 1fr 70px auto;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 0 9px 18px;\n  border-top: 1px solid var(--color-border);\n  font-size: 12px;\n}\n.rp-row:hover { background: var(--color-bg-row); }\n.rp-row__when { color: var(--color-text); }\n.rp-row__fund { color: var(--color-muted); }\n.rp-row__size { color: var(--color-dim); text-align: right; font-variant-numeric: tabular-nums; }\n.rp-row__actions { display: flex; gap: 14px; justify-content: flex-end; padding-right: 4px; }\n\n.rp-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-size: 12px;\n  color: var(--color-accent);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.rp-link:hover:not(:disabled) { text-decoration: underline; }\n.rp-link:disabled { color: var(--color-dim); cursor: default; }\n\n.rp-error { max-width: 1200px; margin: 0 auto 16px; font-size: 12px; color: var(--color-danger); }\n\n.rp-message { display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; padding: 40px 20px; }\n.rp-message__title { margin: 0; font-size: 14px; font-weight: 600; color: var(--color-text); }\n.rp-message .rp-btn { margin-top: 8px; }\n\n/* Loading placeholders */\n.rp-skeleton {\n  display: block;\n  border-radius: 4px;\n  background: linear-gradient(90deg, var(--color-bg-row) 25%, var(--color-border) 50%, var(--color-bg-row) 75%);\n  background-size: 200% 100%;\n  animation: rp-shimmer 1.4s ease-in-out infinite;\n}\n.rp-skeleton--short { width: 90px; height: 10px; }\n.rp-skeleton--title { width: 160px; height: 16px; margin: 4px 0; }\n.rp-skeleton--meta  { width: 220px; height: 10px; }\n.rp-skeleton--row   { height: 14px; margin: 14px 0; }\n\n@keyframes rp-shimmer {\n  from { background-position: 200% 0; }\n  to   { background-position: -200% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rp-skeleton { animation: none; }\n}\n\n@media (max-width: 640px) {\n  .rp-row { grid-template-columns: 1fr auto; padding-left: 4px; }\n  .rp-row__fund { display: none; }\n  .rp-row__actions { grid-column: 1 / -1; justify-content: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
